export const promoVipOneRubleLoginPath = 'login'
